import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import GeniustextInput from '../utility/component/mastertext';
import ModalHeaderStyle from '../utility/component/styles/modalHeader';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { setAlertWithTitle, setSpinnerLoading } from '../utility/Redux/modal';
import { CallAPIPromise } from '../routeBilling/menu/dashboard/biiling/modal/comman';
import { defaultDataWhatspp } from './messageSetupMaster';
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '16px',
  maxWidth: 600,
  width: '90%',
};

const CreditTopUpModal = ({
  open,
  onClose,
  onSubmit,
  setSaveData,
  windowWidth,
  data,
}) => {
  const [formData, setFormData] = useState({
    id: '',
    date: moment().format('YYYY-MM-DD'),
    company_email: '',
    whatsapp_number: '',
    messenger_id: '',
    account_sid: '',
  });
  const dispatch = useDispatch();
  const [whatsappCreditUsed, setwhatsappCreditUsed] = useState('');
  const [smsCreditUsed, setsmsCreditUsed] = useState('');

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleSubmit = () => {
    const payload = {
      ...formData,
      whatsapp_credits: whatsappCreditUsed,
      sms_credits: smsCreditUsed,
    };
    dispatch(setSpinnerLoading('Loading'));
    CallAPIPromise('/api/whatsApp/message_top_up', payload)
      .then(() => {
        setSaveData(defaultDataWhatspp);
        onClose();
        setFormData({
          id: '',
          date: moment().format('YYYY-MM-DD'),
          company_email: '',
          whatsapp_number: '',
          messenger_id: '',
          account_sid: '',
        });
        setwhatsappCreditUsed(0);
        setsmsCreditUsed(0);
        dispatch(
          setAlertWithTitle({
            title: 'Alert',
            msg: 'Data Saved',
          })
        );
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
    onSubmit(payload);
    onClose();
  };

  useEffect(() => {
    if (open) {
      setFormData({
        id: '',
        date: moment().format('YYYY-MM-DD'),
        company_email: data.company_email,
        whatsapp_number: data.whatsapp_number,
        messenger_id: data.messenger_id,
        account_sid: data.account_sid,
      });
    }
  }, [data, open]);
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <ModalHeaderStyle
          onClose={onClose}
          header={'WhatsApp & SMS Credit Top-Up'}
        />

        <div className="p-4">
          <div className="grid grid-cols-2 gap-3">
            <GeniustextInput
              title="Company Email"
              type={'text'}
              value={formData.company_email}
              onChange={handleChange('company_email')}
              width={windowWidth <= 500 ? '100px' : '195px'}
              grid={true}
            />
          </div>

          <div className="grid grid-cols-2 gap-3 mt-4">
            <GeniustextInput
              type="number"
              title={
                windowWidth <= 500 ? 'Add wApp Credit' : 'Add WhatsApp Credit'
              }
              value={whatsappCreditUsed}
              onChange={(e) => setwhatsappCreditUsed(e.target.value)}
              width={windowWidth <= 500 ? '100px' : '195px'}
              grid={true}
            />
            <GeniustextInput
              type="number"
              title={windowWidth <= 500 ? 'Add SMS Cr. ' : 'Add SMS Credit '}
              value={smsCreditUsed}
              onChange={(e) => setsmsCreditUsed(e.target.value)}
              width={windowWidth <= 500 ? '100px' : '195px'}
              grid={true}
            />
          </div>

          <div className="flex justify-end gap-2 mt-6">
            <Button onClick={onClose} variant="outlined">
              Cancel
            </Button>
            <Button onClick={handleSubmit} variant="contained" color="primary">
              Top Up
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default CreditTopUpModal;
